import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'temptik-solution',
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionComponent {}
